import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

/**
 * IntroCinematique — 2.5s full-screen logo flash, skippable.
 * Shown once per session (sessionStorage).
 */
export const IntroCinematique = () => {
  const [visible, setVisible] = useState(() => {
    if (typeof window === "undefined") return false;
    return !localStorage.getItem("fd_intro_seen");
  });

  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(() => {
      setVisible(false);
      localStorage.setItem("fd_intro_seen", "1");
    }, 1500);
    const onKey = (e) => {
      if (e.key === "Escape" || e.key === " " || e.key === "Enter") {
        setVisible(false);
        localStorage.setItem("fd_intro_seen", "1");
      }
    };
    window.addEventListener("keydown", onKey);
    return () => { clearTimeout(t); window.removeEventListener("keydown", onKey); };
  }, [visible]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="intro-cinema"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-0 z-[10000] bg-fd-bg flex items-center justify-center"
        >
          <motion.div
            initial={{ scale: 0.85, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="relative"
          >
            <motion.div
              animate={{
                textShadow: [
                  "0 0 0px rgba(212,162,76,0)",
                  "0 0 40px rgba(212,162,76,0.6)",
                  "0 0 0px rgba(212,162,76,0)",
                ],
              }}
              transition={{ duration: 1.8, ease: "easeInOut" }}
              className="display-xl text-5xl md:text-7xl lg:text-9xl text-gradient-gold text-center leading-none"
            >
              Frites.Dorées
            </motion.div>
            <motion.p
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.8 }}
              className="mono-label-gold mt-4 text-center"
            >
              Direct · Dark · Doré
            </motion.p>
          </motion.div>
          <button
            data-cursor-hover
            onClick={() => { setVisible(false); localStorage.setItem("fd_intro_seen", "1"); }}
            aria-label="Passer l'intro"
            className="absolute bottom-10 left-1/2 -translate-x-1/2 px-5 py-2.5 mono-label hover:text-fd-gold border border-fd-border hover:border-fd-gold rounded-full transition-all duration-300"
          >
            Passer →
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
